export default __webpack_public_path__ + "static/media/MASERATI.8bfe21c7.png";